{#if valid}
    <div class="input-group">
        <input value={coupon} disabled type="text" class="form-control">
        <div class="input-group-append">
            <button class="btn btn-success"><i class="fas fa-check" /></button>
        </div>
    </div>

    <slot></slot>

{:else if checking}
    <div class="input-group">
        <input value={coupon} disabled type="text" class="form-control">
        <div class="input-group-append">
            <button class="btn btn-secondary"><i class="fas fa-spinner fa-spin" /></button>
        </div>
    </div>

{:else}
    <div class="input-group">
        <input bind:this={field} bind:value={coupon} required placeholder={$_("unseated.form.coupons.placeholder")} type="text" class="form-control">
        <div class="input-group-append">
            {#if !error}
                <button class="btn btn-primary" on:click={check}><i class="fas fa-arrow-right" /></button>
            {:else}
                <button class="btn btn-danger" on:click={check}><i class="fas fa-times" /></button>
            {/if}
        </div>

        {#if error}
            <div class="invalid-feedback">{ $_("unseated.form.coupons.errors") }</div>
        {/if}
    </div>
{/if}

<style lang="less">
    .invalid-feedback {
        display: block;
    }

    .input-group {
        padding-top: 0.5rem;
    }
</style>

<script lang="ts">
    import { custom_setting } from "@/frontend/base/state";
    import { _ } from "@frontend/translations";
    import { Category, Shop, EventPriceInformation } from "@ticketmachine/sdk";

    let valid = false;
    let checking = false;

    let field: HTMLInputElement;

    export let coupon: string = "";
    export let ownKey: string = "";
    let error = false;

    export let readAllCoupons: (() => Record<string, {getCouponCode: () => string|null, getCurrentCode: () => string}>) = () => {};


    export const isValid = () => valid;
    export const getCouponCode = () => valid ? coupon : null;
    export const getCurrentCode = () => coupon || "";
    export const reportValidity = () => {
        if (valid) return;
        field?.setCustomValidity($_("unseated.form.coupons.validity"));
        field?.reportValidity();
    };

    const resetError = (_: any) => error = false;
    $: resetError(coupon);

    function parseCatMapKey(key: string, idx=0): number {
        return Number(key.split(":")[0].split("-")[idx]);
    }

    const COUPON_REGEX = /^\/((?:\\\/|[^\/])+)\/((?:\\\/|[^\/])*)\/([gimsuy]*)$/;
    function applyCouponRegex(regex: string, code: string|null): string|null {
        if (!code) return code;
        if (regex === "") return code;
        const match = COUPON_REGEX.exec(regex);
        if (!match) return code;

        const substituter = new RegExp(match[1], match[3]);
        return code.replace(substituter, match[2]);
    }

    async function check() {
        if (coupon === "") return;
        const coupon_regex = await custom_setting<string>("coupon_regex")

        field?.setCustomValidity("");

        const allCoupons = readAllCoupons();

        const eCache: Record<string, EventPriceInformation> = {};
        const ticketCache: Record<string, Category> = {};
        for (let k of Object.keys(allCoupons)) {
            const eid = parseCatMapKey(k, 0);
            const cid = parseCatMapKey(k, 1);

            if (eCache[""+eid]) {
            }
            const ev =
                (!!eCache[""+eid]) ? eCache[""+eid] : (
                    eCache[""+eid] = await Shop.current.getEventPrices(eid)
                );
            if (!ev) throw new Error("Failed to receive event.");

            const cat = ev.categories.find(c => c.id === cid);
            if (!cat) throw new Error("Failed to find category.");

            ticketCache[k] = cat;
        }

        checking = true;
        error = false;
        try {
            await Shop.current.tryTransaction(async (s: Shop) => {
                for (let [k, v] of Object.entries(allCoupons)) {
                    const cat = ticketCache[k];
                    const code = v.getCurrentCode();
                    const actualCode = applyCouponRegex(coupon_regex || "", code);
                    if (k === ownKey) {
                        await s.cart.add(cat, 1, {coupon: actualCode!});
                    } else if (!!code) {
                        await s.cart.add(cat, 1, {coupon: actualCode!})
                    }
                }
            });

            valid = true;
        } catch (e) {
            error = true;
            if ((e as any)?.isAxiosError) {
                console.warn(e);
            } else {
                window.reportError(e);
            }
        } finally {
            checking = false;
        }
    }
</script>
